import envStore from '@/env'

export const DECIMAL_CONFIG = {
  Number: {
    digits: envStore.decimalNumber,
    padWithZero: true,
  },
  Percentage: {
    digits: 2,
    padWithZero: true,
  },
  // 排放係數 小數點到第10位四捨五入
  EmissionCoeffi: {
    digits: 10,
    padWithZero: false,
  },
}

/** 統計圖度數套用 envStore 的小數點 */
/**
 * 統計管理 admin_reportMgm
 */
// export const REPORT_DECIMAL_CONFIG = {
//   Number: {
//     digits: 4,
//     padWithZero: true,
//   },
//   Percentage: {
//     digits: 2,
//     padWithZero: true,
//   },
// }
/**
 * expoNumber = 套的是環境的預設值
 * percentNumber = 套的是環境的預設值
 * toLimitNumber = 套的是環境的預設值
 * toEquivalentEmissionFormat= 套的是環境的預設值
 * toEmissionCoeffiFormat =排放係數 固定小數點 10
 * positiveNumber = 套的是環境的預設值
 * convertPercentage = 套的是環境的預設值
 *
 * * 統計圖表 > 減碳目標資訊
 * toEmissionFormatByDecimal 預設 2
 *
 * toNumberFormatByDecimal 預設 2 不顯示科學符號
 * toThousandSeparator = 套的是環境的預設值
 * toThousandSeparatorV0 = 沒有小數點設定
 */
